import Header from './components/header';
import Hero from './components/hero';
import Services from './components/servicio';
import Testimonials from './components/testimoniales';
import Promotions from './components/promociones';
import Team from './components/team';
import Contact from './components/contacto';
import Footer from './components/footer';
import { palette, socialLinks } from './style_palete';
import { MessageCircle } from 'lucide-react';
import ObrasSociales from "./components/obrasocial";


export default function KalmaresLanding() {
  return (
    <div className="min-h-screen w-full text-[15px]" style={{ color: palette.ink, background: `linear-gradient(180deg, ${palette.sky}, #fff)` }}>
      
      {/* gradient  */}
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full blur-3xl opacity-40" style={{ background: palette.primarySoft }} />
        <div className="absolute top-48 -right-24 h-80 w-80 rounded-full blur-3xl opacity-30" style={{ background: palette.teal }} />
      </div>


      <Header />
      <Hero />
      <Services />
      <Testimonials />
      <Promotions />
      <Team />
      <ObrasSociales />
      <Contact />
      <Footer />

    
      <a 
        href={socialLinks.whatsapp} 
        target="_blank" 
        rel="noreferrer" 
        className="fixed bottom-6 right-6 inline-flex items-center gap-2 rounded-full px-5 py-4 font-semibold text-white shadow-2xl hover:shadow-3xl hover:scale-110 transition-all z-50"
        style={{ 
          background: `linear-gradient(135deg, ${palette.teal}, ${palette.primary})`,
          fontSize: '16px'
        }}
      >
        <MessageCircle className="h-5 w-5" />
        WhatsApp
      </a>

    </div>
  );
}
